<template>
  <div class="MyaccountFAQ" v-if="productFaq.length>0">
    <h3 class="MyaccountFAQ_title">{{ $t('myaccount.support.faq.title', "FAQ's") }}</h3>
    <app-accordion-list>
      <app-accordion
        v-for="(item, index) in productFaq"
        :key="index"
        :index="index+1"
        :title="'faq:' + (index + 1)"
        :id="'faq-' + (index + 1)"
      >
        <template slot="title">
          <p v-html="item.title"></p>
        </template>
        <template slot="body">
          <div class="Faq">
            <p class="tip" v-html="item.content">
            </p>
          </div>
        </template>
      </app-accordion>
    </app-accordion-list>
  </div>
</template>

<script>
  export default {
    name: 'my-account-faq',

    props: {
      productFaq: {
        type: Array,
        required: true
      }
    }
  }
</script>

<style lang="scss">
  .MyaccountFAQ {
    margin-top: .54rem;

    @include media(tablet) {
      margin-top: .36rem;
    }

    &_title {
      color: #0066a1;
      font-size: .24rem;
      line-height: 1;
      margin-bottom: .2rem;
    }

    &_tips {
      margin-top: .32rem;
      margin-bottom: -.3rem;
      font-size: .16rem;
      margin-left: .1rem;

      @include media(tablet) {
        margin-top: .29rem;
      }

      .link {
        color: #0066a1;
        font-weight: 700;
        font-size: .16rem;
      }
    }

    .Accordion_list {
      .AppButton {
        width: 100%;
        padding-top: .07rem;
      }

      .Accordion_title {
        color: #0066a1;
        font-size: .14rem;
      }

      .Accordion_header {
        background-color: rgba(0, 102, 161, .15);
        border-radius: .02rem;

        .icon-chevron-thin-down {
          color: #176498;
        }
      }
    }

    .Accordion_body {
      background: #fff;
      padding: 0 0;

      @include media(tablet) {
        padding: 0 .19rem 0;
      }

      .Faq {
        .tip {
          color: #4a4a4a !important;
          font-size: .14rem;
          font-weight: 400;
          line-height: .22rem;
          padding: .22rem .4rem .26rem .1rem;

          @include media(tablet) {
            font-size: .14rem;
            padding-left: 0;
            line-height: .24rem;
          }
        }
      }
    }
  }
</style>
